import { Reducer } from 'redux'
import { CounteredToppedAlert, TradingNowAlert } from '../alerts/types'
import { SettingsAction } from './actions'
import { injectWindowSettingsIntoState } from './helpers'
import {
  ListTradingTemplateSetting,
  StickyGridState,
  WatchlistWindowSetting
} from './types'

export interface State {
  windowSettings: WatchlistWindowSetting[]
  aggressAttemptSettings?: StickyGridState
  rfqSettings?: StickyGridState
  passiveOrdersSettings?: StickyGridState
  tradeBlotterSettings?: StickyGridState
  guiUserDataSettings?: StickyGridState
  externalLiquiditySettings?: StickyGridState
  apiUserDataSettings?: StickyGridState
  listTradingSettings?: StickyGridState
  userDashboardSettings?: StickyGridState
  tradingNowAlerts: TradingNowAlert[]
  counteredToppedAlerts: CounteredToppedAlert[]
  areSettingsLoaded: boolean
  listTradingTemplateSetting: ListTradingTemplateSetting
}

export const initialState: State = {
  windowSettings: [],
  tradingNowAlerts: [],
  counteredToppedAlerts: [],
  areSettingsLoaded: false,
  listTradingTemplateSetting: { template: 'Standard', isSpread: true }
}

export const settingsReducer: Reducer<State, SettingsAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'settings.updateGridState':
      const { filterModel, columnState } = action.payload
      const formattedFilterModel =
        filterModel && Object.keys(filterModel).length > 0 ? filterModel : null
      return {
        ...state,
        [action.payload.gridName]: {
          columnState,
          filterModel: formattedFilterModel
        }
      }
    case 'settings.saveListTradingTemplateSelection': {
      const setting = action.payload
      return {
        ...state,
        listTradingTemplateSetting: setting
      }
    }
    case 'settings.loadWindowSettingsSuccess': {
      const { settings } = action.payload
      return {
        ...state,
        listTradingTemplateSetting: settings.listTradingTemplateSetting
      }
    }
    default:
      return state
  }
}

// This reducer acts on the global state, not only for “settings” namespace.
export const globalSettingsReducer: Reducer<any, SettingsAction> = (
  state,
  action
) => {
  switch (action.type) {
    case 'settings.loadWindowSettings':
      const StickyGridStates = {
        aggressAttemptSettings:
          action.payload.settings.aggressAttemptWindowSettings,
        rfqSettings: action.payload.settings.rfqWindowSettings,
        passiveOrdersSettings:
          action.payload.settings.passiveOrdersWindowSettings,
        tradeBlotterSettings:
          action.payload.settings.tradeBlotterWindowSettings,
        guiUserDataSettings: action.payload.settings.guiUserDataWindowSettings,
        externalLiquiditySettings:
          action.payload.settings.externalLiquidityWindowSettings,
        apiUserDataSettings: action.payload.settings.apiUserDataWindowSettings,
        listTradingSettings: action.payload.settings.listTradingWindowSettings,
        userDashboardSettings:
          action.payload.settings.userDashboardWindowSettings
      }
      return injectWindowSettingsIntoState(
        action.payload.settings.watchlistWindowSettings,
        StickyGridStates,
        action.payload.settings.mutedTradingNowAlerts,
        action.payload.settings.mutedCounteredAlerts,
        action.payload.settings.mutedToppedAlerts,
        action.payload.settings.depthSecurityIds,
        action.payload.settings.maxDOMs,
        state
      )
    default:
      return state
  }
}
